module.exports = __webpack_public_path__ + "img/9.d8b8d8d4.jpeg";